export function sanitizeEmojiString(value: string): string {
  if (!value) {
    return value;
  }
  return value.replace(/[^\x20-\x7E]/g, '');
}

export function sanitizeEmoji(event: Event): string {
  const inputEl = event.target as HTMLInputElement;
  if (!inputEl.value) {
    return inputEl.value;
  }

  const cleaned = sanitizeEmojiString(inputEl.value);
  if (cleaned !== inputEl.value) {
    inputEl.value = cleaned;
  }

  return cleaned;
}
